import React from "react";
import { PayoutOutcomeEditor } from "../../../../components/opportunities/payoutOutcomeEditor";
import {
  getOutcomePolicyFormValue,
  type OutcomeRegistry,
  type OutcomeRegistryRow,
  type OutcomePolicyFormValue,
  type PayoutComponent,
} from "../../../../utils/opportunities/outcomeRegistryHelpers";
import { getByPath, type PreviewValues } from "../opportunityFormCommon";
import { formatOptionLabelsForUi } from "../opportunityFormHelpers";
import type { TemplateStepLike } from "../opportunityFormTypes";

type OutcomeRegistryStepProps = {
  step: TemplateStepLike;
  outcomeRegistry: OutcomeRegistry;
  previewValues: PreviewValues;
  payoutComponents: PayoutComponent[];
  updateValue: (path: string, value: unknown) => void;
  resolveOptionsFrom: (
    optionsFrom: string,
  ) => { label: string; value: string }[];
  translateFieldText: (key: string) => string;
};

export const OutcomeRegistryStep: React.FC<OutcomeRegistryStepProps> = ({
  step,
  outcomeRegistry,
  previewValues,
  payoutComponents,
  updateValue,
  resolveOptionsFrom,
  translateFieldText,
}) => (
  <PayoutOutcomeEditor
    outcomeRegistry={outcomeRegistry}
    baseAmount={Number(getByPath(previewValues, 'core.baseAmount') || 0)}
    currency={String(getByPath(previewValues, 'core.currency') || '')}
    allComponents={payoutComponents}
    getPolicyValue={(row: OutcomeRegistryRow) => getOutcomePolicyFormValue(row, getByPath(previewValues, `${step.stepId}.outcomes.${row.key}`))}
    updatePolicyValue={(row: OutcomeRegistryRow, patch: Partial<OutcomePolicyFormValue>) => {
      const current = getOutcomePolicyFormValue(row, getByPath(previewValues, `${step.stepId}.outcomes.${row.key}`));
      updateValue(`${step.stepId}.outcomes.${row.key}`, { ...current, ...patch });
    }}
    resolveRegistryOptions={(optionsFrom?: string) => optionsFrom ? formatOptionLabelsForUi(resolveOptionsFrom(optionsFrom)) : []}
    tr={translateFieldText}
  />
);